import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";

export default class UrzadBiletyJednorazoweTable extends Component {
    constructor(props) {
        super(props);
        this.state = {

            defaultFilterKod: false,
            statusy: [
                {value: -1, label: 'do opłaty', ikona: 'fa fa-times-circle-o', kolor: '#333'},
                {value: 1, label: 'opłacony', ikona: 'fa fa-check-circle-o', kolor: '#333'},
                {value: 0, label: 'rezerwacja', ikona: 'fa fa-circle-o', kolor: '#333'},
                {value: 2, label: 'skasowany', ikona: 'fa fa-circle', kolor: '#333'},
                {value: -2, label: 'anulowano kl', ikona: 'fa fa-user-times', kolor: '#333'},
                {value: -3, label: 'anulowano op', ikona: 'fa fa-user-secret', kolor: '#333'},
                {value: -4, label: 'zwrócony', ikona: 'fa fa-refresh', kolor: '#333'},
                {value: -5, label: 'nieopłacony', ikona: 'fa fa-times', kolor: '#000'},

            ],

            kolumnyDoExportuDefault: [
                {value: "id_bi", label: "ID biletu"},
                {value: "id_bp", label: "ID biletu pozycji"},
                {value: "data_sprz", label: "Data sprzedaży"},
                {value: "nr_linii", label: "Nr linii"},
                {value: "trasa", label: "Trasa"},
                {value: "odcinek_trasy", label: "Odcinek trasy"},
                {value: "km", label: "KM"},
                {value: "id_ku", label: "ID kursu"},
                {value: "data_ku", label: "Data kursu"},
                {value: "godz_kursu", label: "Godzina kursu"},
                {value: "nr_bileterki", label: "Nr bileterki"},
                {value: "ilosc", label: "Ilość"},
                {value: "nr_gr_ulgi", label: "Nr grupy ulgi"},
                {value: "nr_ulgi", label: "Nr ulgi"},
                {value: "nazwa_ulgi", label: "Nazwa ulgi"},
                {value: "proc_ulgi", label: "Procent ulgi"},
                {value: "ilosc_popr", label: "Czy ilość poprawna?"},
                {value: "cena_biletu", label: "Cena biletu"},
                {value: "doplata", label: "Dopłata"},
                {value: "cena_biletu_netto", label: "Cena biletu netto"},
                {value: "doplata_netto", label: "Dopłata netto"},
            ],
            wszystkieKolumnyEksport: [
                {value: "id_bi", label: "ID biletu"},
                {value: "id_bp", label: "ID biletu pozycji"},
                {value: "data_sprz", label: "Data sprzedaży"},
                {value: "nr_linii", label: "Nr linii"},
                {value: "trasa", label: "Trasa"},
                {value: "odcinek_trasy", label: "Odcinek trasy"},
                {value: "km", label: "KM"},
                {value: "id_ku", label: "ID kursu"},
                {value: "data_ku", label: "Data kursu"},
                {value: "godz_kursu", label: "Godzina kursu"},
                {value: "nr_bileterki", label: "Nr bileterki"},
                {value: "ilosc", label: "Ilość"},
                {value: "nr_gr_ulgi", label: "Nr grupy ulgi"},
                {value: "nr_ulgi", label: "Nr ulgi"},
                {value: "nazwa_ulgi", label: "Nazwa ulgi"},
                {value: "proc_ulgi", label: "Procent ulgi"},
                {value: "ilosc_popr", label: "Czy ilość poprawna?"},
                {value: "cena_biletu", label: "Cena biletu"},
                {value: "doplata", label: "Dopłata"},
                {value: "cena_biletu_netto", label: "Cena biletu netto"},
                {value: "doplata_netto", label: "Dopłata netto"},
            ],
        };
    }

    componentDidMount() {
    }

    formatNaglowek(str) {
        return <span style={{fontSize: "10px"}}>{str}</span>
    }

    formatSmallText(cell, row) {
        return <span style={{fontSize: "11px"}}>{cell}</span>
    }

    formatCeny(cell, row) {
        return <span style={{fontSize: "11px"}}>{cell.toFixed(2)}</span>
    }


    formatIloscPopr(cell, row) {
        if (row.ilosc == cell) {
            return <span style={{fontSize: "11px"}}>{cell}</span>
        } else {
            return <div style={{fontSize: "11px", background: "yellow", color: "red", fontWeight: "bold"}}
                        title={"Ilość sprzedana i poprawna się nie zgadzają!"}>{cell}</div>
        }
    }


    render() {

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
        };

        return (
            <div>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość wyszukanych rekordów: {Boolean(this.props.data) ? this.props.data.length : 0}
                    </div>
                </div>
                <div id={'UrzadJednorazoweTable'}>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    pagination
                                    hover
                    >
                        <TableHeaderColumn dataField='id_bi' dataSort isKey
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("ID biletu")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='data_sprz' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Data sprzedaży")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='nr_linii' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Linia nr")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='trasa' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Trasa")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='odcinek_trasy' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Odcinek")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='km' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("KM")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='id_ku' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("ID kursu")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='data_ku' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Data kursu")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='godz_kursu' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Godz kursu")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='nr_bileterki' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Bileterka nr")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='nr_gr_ulgi' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Ulga grupa")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwa_ulgi' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Ulga nazwa")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='proc_ulgi' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Ulga %")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='ilosc' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatSmallText(cell, row)}
                        >{this.formatNaglowek("Ilość sprzedana")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='ilosc_popr' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatIloscPopr(cell, row)}
                        >{this.formatNaglowek("Ilosc poprawna")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_biletu' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatCeny(cell, row)}
                        >{this.formatNaglowek("Cena biletu")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='doplata' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatCeny(cell, row)}
                        >{this.formatNaglowek("Dopłata")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='cena_biletu_netto' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatCeny(cell, row)}
                        >{this.formatNaglowek("Cena biletu netto")}</TableHeaderColumn>
                        <TableHeaderColumn dataField='doplata_netto' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => this.formatCeny(cell, row)}
                        >{this.formatNaglowek("Dopłata netto")}</TableHeaderColumn>

                    </BootstrapTable>
                </div>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/bilety_jednorazowe/compontents/UrzadBiletyJednorazoweTable.js